import React from "react";
import Link from "components/link";
import { useSettings } from "hooks/useStore";
import { trackNavClick } from "analytics";

const DirectLink = ({ data, className, setShowOverlay }) => {
	const { toggleMenu } = useSettings(["toggleMenu"]);

	const handleOnFocus = () => {
		toggleMenu(false);
		setShowOverlay(false);
	};

	return (
		<Link to={data.url} tabIndex="0" className="text-center"
			onFocus={handleOnFocus} onClick={() => trackNavClick(data.title)}>
			<span className={className}>
				{data.title}
			</span>
		</Link>
	);
};

export default DirectLink;